import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import * as styles from './styles'

const MobileInwinsFiltersComponent = ({ activeTab, onTabChange }) => {
	// Create tabs array for Inwins and Beneficiaries
	const tabs = [
		{ id: 'inwins', label: 'Inwins' },
		{ id: 'beneficiaries', label: 'Beneficiaries' },
	]

	return (
		<>
			{tabs.map((tab) => {
				const isSelected = activeTab === tab.id

				return (
					<button
						key={tab.id}
						css={[styles.tab, isSelected && styles.activeTab]}
						onClick={() => onTabChange(tab.id)}
						type="button"
					>
						<Text
							size={12}
							bold={isSelected}
							css={[styles.tabText, isSelected && styles.activeTabText]}
						>
							{tab.label}
						</Text>
					</button>
				)
			})}
		</>
	)
}

MobileInwinsFiltersComponent.propTypes = {
	activeTab: PropTypes.string.isRequired,
	onTabChange: PropTypes.func.isRequired,
}

export default MobileInwinsFiltersComponent 